<template>
  <div>
    <div>
      <img :style="{'height': height}" class="welcomeImg" :src="welcomeImg" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      welcomeImg:'',
      height:'',
    }
  },
  methods:{
    async getWelcomImg() {
      let loginData = JSON.parse(localStorage.getItem('loginData'))
      let id = loginData.areaId
      if (id == '') {
        this.welcomeImg = require('@/assets/welcome.png')
      } else {
        await this.$api.getPublicFileUrl().then(res => {
          this.publicFileUrl = res.data.data
        })
        this.$api.getSystem(id).then(res => {
          if (res.data.status == 0) {
            let _R = JSON.parse(res.data.data)
            if (_R.welcomeImg == '') {
              this.welcomeImg = require('@/assets/welcome.png')
            } else {
              this.welcomeImg = this.publicFileUrl+ '/' + _R.welcomeImg
            }
          } else {
            this._status(res.data)
          }
        })
      }
    }
  },
  created() {
    this.height = document.body.clientHeight - 115 + 'px'
  },
  mounted() {
    this.getWelcomImg()
  },
}
</script>

<style lang='scss' scoped>
.welcomeImg{
  width:100%;
  position: relative;
  top: -15px;
}
</style>